module.exports = __webpack_public_path__ + "img/bantuan.2f428370.png";